import { mockUpdates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            实时追踪漫画更新动态，热门连载与最新入库作品一网打尽
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {mockUpdates.map((item, i) => (
              <div key={i} className="relative pb-6 last:pb-0">
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${item.typeColor} w-fit whitespace-nowrap`}>
                    {item.type}
                  </span>
                </div>
                <p className="text-sm text-foreground-800 font-medium">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}